import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myLeaveRoleFiltersPrevState = atom({
  key: "myLeaveRoleFiltersPrevState",
  default: {
    company: [],
    orgUnit: [],
    workingPlace: [],
    jobClassGroup: [],
    payOffice: [],
    contract: [],
  },
  effects_UNSTABLE: [ocPersistAtom],
});
